import { ACTION as constants } from './constants';

export function CommandEvaluableGet(elementId, elementType) {
  return {
    type: constants.AUTHOR_EVALUABLE_GET,
    elementId,
    elementType,
  };
}

export function EvaluablePut(elementId, elementType, evaluationMode) {
  return {
    type: constants.AUTHOR_EVALUABLE_PUT,
    elementId,
    elementType,
    evaluationMode,
  };
}

export function CommandEvaluableSet(elementId, elementType, evaluationMode) {
  return {
    type: constants.AUTHOR_EVALUABLE_SET,
    elementId,
    elementType,
    evaluationMode,
  };
}

export function CommandEvaluableDelete(componentId) {
  return {
    type: constants.AUTHOR_EVALUABLE_DELETE,
    componentId,
  };
}

export function ResponseAuthorEvaluableGet() {
  return {
    type: constants.AUTHOR_EVALUABLE_GET_RESPONSE,
  };
}

export function ResponseAuthorEvaluableGetError() {
  return {
    type: constants.AUTHOR_EVALUABLE_GET_ERROR,
  };
}

export function ResponseAuthorEvaluableMutate() {
  return {
    type: constants.AUTHOR_EVALUABLE_MUTATE_RESPONSE,
  };
}

export function ResponseAuthorEvaluableMutateError() {
  return {
    type: constants.AUTHOR_EVALUABLE_MUTATE_ERROR,
  };
}
